import { apiClient } from "@vv/api";
import type { AppUser, InviteUserRequest, UpdateUserRequest } from "../domain/user.types";

export const usersApi = {
  list: (search?: string) =>
    apiClient.get<AppUser[]>(`/users${search ? `?search=${encodeURIComponent(search)}` : ""}`),

  get: (id: string) => apiClient.get<AppUser>(`/users/${id}`),

  update: (id: string, payload: UpdateUserRequest) =>
    apiClient.patch<AppUser>(`/users/${id}`, payload),

  invite: (payload: InviteUserRequest) => apiClient.post<AppUser>("/users/invite", payload),
};
